(function () {
  /* ---------------------------------------------------------
     1. Bandeau newsletter (GIF)
  --------------------------------------------------------- */
  var slot = document.getElementById('luther-newsletter-slot');
  if (slot) {
    var appearAfter = parseInt(slot.getAttribute('data-appear-after'), 10) || 4000;
    var newsletterHideAfter = parseInt(slot.getAttribute('data-newsletter-hide-after'), 10) || 3000;

    var newsletterWidget = document.getElementById('luther-newsletter-widget');
    var newsletterClose = document.getElementById('luther-newsletter-close');
    var newsletterTimer = null;

    function hideNewsletter() {
      if (newsletterTimer) {
        clearTimeout(newsletterTimer);
        newsletterTimer = null;
      }
      if (newsletterWidget) {
        newsletterWidget.classList.remove('is-visible');
      }
    }

    function startNewsletterCountdown() {
      setTimeout(function () {
        if (newsletterWidget) {
          newsletterWidget.classList.add('is-visible');
          newsletterTimer = setTimeout(hideNewsletter, newsletterHideAfter);
        }
      }, appearAfter);
    }

    // Le compte à rebours ne démarre qu'une fois le CAPTCHA validé —
    // sinon, sur mobile, le temps passé à taper le mot était compté
    // à tort et la newsletter apparaissait "instantanément" après.
    if (window.__lutherGatePassed) {
      startNewsletterCountdown();
    } else {
      document.addEventListener('luthergatepassed', startNewsletterCountdown, { once: true });
    }

    if (newsletterClose) {
      newsletterClose.addEventListener('click', hideNewsletter);
    }
  }

  /* ---------------------------------------------------------
     2. Carte pub (GIF, boucle infinie) — ferme au clic sur la croix
  --------------------------------------------------------- */
  var adsWidget = document.getElementById('luther-ads-widget');
  var adsClose = document.getElementById('luther-ads-close');

  if (adsWidget) {
    window.requestAnimationFrame(function () {
      adsWidget.classList.add('is-visible');
    });
  }

  if (adsClose && adsWidget) {
    adsClose.addEventListener('click', function () {
      adsWidget.classList.remove('is-visible');
    });
  }

  /* ---------------------------------------------------------
     3. Popup CRM (remplace l'ancien popup Shotgun) : apparaît
     après un délai fixe (plus de déclenchement au scroll, trop
     peu fiable selon la position des sections), disparition
     automatique 3s après. Le minuteur ne démarre qu'une fois le
     CAPTCHA validé, comme pour la newsletter.
  --------------------------------------------------------- */
  var crmScrollPopup = document.getElementById('luther-crm-scroll-popup');
  if (crmScrollPopup) {
    var crmAppearAfter = parseInt(crmScrollPopup.getAttribute('data-appear-after'), 10) || 7000;
    var crmScrollHideAfter = parseInt(crmScrollPopup.getAttribute('data-hide-after'), 10) || 3000;
    var closeCrmScroll = document.getElementById('luther-crm-scroll-close');
    var declineCrmScroll = document.getElementById('luther-crm-scroll-decline');

    function dismissCrmScroll() {
      crmScrollPopup.classList.remove('is-visible');
    }

    function showCrmScroll() {
      crmScrollPopup.classList.add('is-visible');
      setTimeout(dismissCrmScroll, crmScrollHideAfter);
    }

    function startCrmScrollCountdown() {
      setTimeout(showCrmScroll, crmAppearAfter);
    }

    if (window.__lutherGatePassed) {
      startCrmScrollCountdown();
    } else {
      document.addEventListener('luthergatepassed', startCrmScrollCountdown, { once: true });
    }

    if (closeCrmScroll) {
      closeCrmScroll.addEventListener('click', dismissCrmScroll);
    }
    if (declineCrmScroll) {
      declineCrmScroll.addEventListener('click', dismissCrmScroll);
    }
  }
})();
